import React, { type ReactNode } from 'react';
import * as Icons from '@ant-design/icons';

export function getStorefrontIcon(name?: string): ReactNode {
  if (!name) return null;
  if (name.startsWith('http://') || name.startsWith('https://') || name.startsWith('/')) {
    return (
      <img
        src={name}
        alt=''
        style={{ width: '1em', height: '1em', objectFit: 'contain' }}
      />
    );
  }
  const IconComponent = (
    Icons as unknown as Record<string, React.ComponentType>
  )[name];
  if (IconComponent) {
    return React.createElement(IconComponent);
  }
  return null;
}
